// KanbanIssueNode.tsx
import type { IIssueApi } from "@schemas/issueSchema";
import { Handle, Node, NodeProps, Position } from "@xyflow/react";
import { memo, useCallback } from "react";
import { setShowFailedMessageThunk } from "../../../../../global/globalSlice";
import { selectCurrentProjectId } from "../../../../../global/globalSliceCommon";
import { useAppDispatch, useAppSelector } from "../../../../../hooks";
import { useDoUpdateIssueMutation } from "../../issueRTK";
import { selectIssueBoardId } from "../../redux/selectors/issueCommonSelectors";
import { KanbanCard } from "../Kanban/KanbanCard/KanbanCard";
import "./lappeplan.css";

type NodeData = { issue: IIssueApi };

const KanbanIssueNode: React.FC<NodeProps<Node<NodeData>>> = ({ id, data }) => {
  const dispatch = useAppDispatch();
  const projectId = useAppSelector(selectCurrentProjectId);
  const issueBoardId = useAppSelector(selectIssueBoardId);
  const [updateIssue] = useDoUpdateIssueMutation();

  const removeNode = useCallback(async () => {
    try {
      await updateIssue({
        projectId,
        issueBoardId,
        issueId: id,
        attr: "noteboardNode",
        value: { ...(data.issue.noteboardNode ?? {}), visible: false },
        oldValue: null,
      }).unwrap();
    } catch {
      dispatch(setShowFailedMessageThunk("Kunne ikke fjerne node"));
    }
  }, [projectId, issueBoardId, id, data.issue.noteboardNode, updateIssue, dispatch]);

  return (
    <div className="rf-issue">
      <div className="rf-card-frame">
        <Handle id="top" type="target" position={Position.Top} className="handle-plus" />
        <KanbanCard content={data.issue} openContent={() => {}} isLappeplan onDisconnectNode={removeNode} />
        <Handle id="bottom" type="source" position={Position.Bottom} className="handle-plus" />
      </div>
    </div>
  );
};

export default memo(KanbanIssueNode);
